module.exports = __webpack_public_path__ + "media/jingle_result.cbe8b850.mp3";